import React, {useEffect, useMemo, useState} from "react";
import moment from "moment";
import {Calendar, DateRange, momentLocalizer, ToolbarProps} from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import './style.css';
import {fetchSchedule} from "features/model/service/groups/schedule/fetchSchedule";
import {useAppDispatch, useAppSelector} from "common/hook";
import 'moment/locale/ru';
import {
    CustomModal
} from "components/pages/groups/group-container/students/students-pages/students-timetable/custom-modal/CustomModal";
import {
    CustomToolbar
} from "components/pages/groups/group-container/students/students-pages/students-timetable/custom-toolbar/CustomToolbar";
import {useParams} from "react-router-dom";
import {formatDate} from "common/utils/calendar/dateUtils";
import EventComponent
    from "components/pages/groups/group-container/students/students-pages/students-timetable/event-component/EventComponent";
import {handleShowMore} from "common/utils/calendar/handleShowMore";
import {EventType} from "features/model/types/EventType";
import {handleSelectSlot} from "common/utils/calendar/handleSelectSlot";


moment.locale("ru");
const localizer = momentLocalizer(moment);

export const StudentsTimetable = () => {
    const dispatch = useAppDispatch();
    const {groupId} = useParams();
    const pendingFilters = useAppSelector((state) => state.filers);
    const scheduleData = useAppSelector(state => state.schedule)
    const [eventsData, setEventsData] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEvents, setSelectedEvents] = useState<any[]>([]);
    const [selectedTimeZone, setSelectedTimeZone] = useState<string | null>(null);
    const [currentMonthYear, setCurrentMonthYear] = useState(new Date());
    const [starting, setStarting] = useState(new Date());
    const [sendFilter, setSendFilter] = useState<boolean>(false)




    const handleShowMoreEvents = (events: EventType[], date: Date) => {
        handleShowMore(events, eventsData, setSelectedEvents, setIsModalOpen);
    };

    const customHandleSelectSlot = ({start, end}: DateRange) => {
        handleSelectSlot(start, end, eventsData, setSelectedEvents, setIsModalOpen, setStarting);
    };


    useEffect(() => {
        if (scheduleData.data && typeof scheduleData.data === 'object') {
            const newEventsData = Object.values(scheduleData.data).flatMap((eventGroup) => (
                eventGroup.map((event) => ({
                    id: event.id,
                    title: event.title,
                    start: new Date(event.startAt),
                    end: new Date(event.finishAt),
                    status: event.status,
                    problems: event.problems,
                    hasProblem: event.hasProblems,
                }))
            ));

            setEventsData(newEventsData);
        }
    }, [scheduleData]);



    const getMonthNumber = (date: Date) => {
        return date.getMonth() + 1;
    };

    const fetchScheduleData = (newDate: Date) => {
        setCurrentMonthYear(newDate)
        const month = getMonthNumber(newDate).toString();
        const year = newDate.getFullYear().toString();
        dispatch(fetchSchedule({
            month: month,
            year: year,
            time_zone: selectedTimeZone,
            new: pendingFilters?.isNew ? 1 : 0,
            finished: pendingFilters?.finished ? 1 : 0,
            has_problem: pendingFilters?.has_problem ? 1 : 0,
            groupId: groupId
        }));
    };



    useEffect(() => {
        const month = getMonthNumber(currentMonthYear).toString();
        const year = currentMonthYear.getFullYear().toString();
        dispatch(fetchSchedule({
            month: month,
            year: year,
            time_zone: selectedTimeZone,
            new: pendingFilters?.isNew ? 1 : 0,
            finished: pendingFilters?.finished ? 1 : 0,
            has_problem: pendingFilters?.has_problem ? 1 : 0,
            groupId: groupId
        }));

    }, [dispatch, sendFilter, selectedTimeZone, groupId]);

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const {components} = useMemo(() => ({
        components: {
            toolbar: (props: ToolbarProps<Event, object>) => (
                <CustomToolbar
                    onNavigate={props.onNavigate}
                    label={props.label}
                    date={props.date}
                    view={props.view}
                    views={props.views}
                    localizer={props.localizer}
                    onView={props.onView}
                    setSelectedTimeZone={setSelectedTimeZone}
                    setSendFilter={setSendFilter}
                />
            ),
            event: (props: any) => (
                <EventComponent
                    status={props.event.status}
                    hasProblem={props.event.hasProblem}
                    start={props.event.start}
                />
            ),
        }
    }), []);

    const formattedDate = formatDate(new Date(starting));

    return (
        <div className='calendarContainer'>
            <Calendar
                views={["month"]}
                selectable
                localizer={localizer}
                defaultDate={new Date()}
                defaultView="month"
                events={eventsData}
                onSelectEvent={customHandleSelectSlot}
                onSelectSlot={customHandleSelectSlot}
                onShowMore={handleShowMoreEvents}
                onNavigate={(newDate, view, action) => fetchScheduleData(newDate)}
                components={components}
            />
            {/*model*/}
            <CustomModal
                selectedEvents={selectedEvents}
                formattedDate={formattedDate}
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
            />

        </div>
    );
};




// import React, {useEffect, useMemo, useState} from "react";
// import moment from "moment";
// import {Calendar, DateRange, momentLocalizer, ToolbarProps} from "react-big-calendar";
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
// import './style.css';
// import {fetchSchedule} from "features/model/service/groups/schedule/fetchSchedule";
// import {useAppDispatch, useAppSelector} from "common/hook";
// import 'moment/locale/ru';
// import {
//     CustomModal
// } from "components/pages/groups/group-container/students/students-pages/students-timetable/custom-modal/CustomModal";
// import {
//     CustomToolbar
// } from "components/pages/groups/group-container/students/students-pages/students-timetable/custom-toolbar/CustomToolbar";
// import {useParams} from "react-router-dom";
// import ApiCalendar from 'react-google-calendar-api';
// import {infoGoogleCalendar, loadingGoogleCalendar, successGoogleCalendar} from "common/utils/calendar/calendarUtils";
// import {googleCalendarConfig} from "common/utils/calendar/googleCalendarConfig";
// import {formatDate} from "common/utils/calendar/dateUtils";
// import EventComponent
//     from "components/pages/groups/group-container/students/students-pages/students-timetable/event-component/EventComponent";
// import {handleShowMore} from "common/utils/calendar/handleShowMore";
// import {EventType} from "features/model/types/EventType";
// import {handleSelectSlot} from "common/utils/calendar/handleSelectSlot";
// import {buildQueryOptions} from "common/utils/calendar/buildQueryOptions";
// import {fetchEventsList} from "common/utils/calendar/fetchEventsList";
//
//
// moment.locale("ru");
// const localizer = momentLocalizer(moment);
//
// export const StudentsTimetable = () => {
//     const dispatch = useAppDispatch();
//     const {groupId} = useParams();
//     const pendingFilters = useAppSelector((state) => state.filers);
//     const scheduleData = useAppSelector(state => state.schedule)
//     const calendarData = useAppSelector(state => state.calendar)
//     const [eventsData, setEventsData] = useState<any[]>([]);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedEvents, setSelectedEvents] = useState<any[]>([]);
//     const [selectedTimeZone, setSelectedTimeZone] = useState<string | null>(null);
//     const [currentMonthYear, setCurrentMonthYear] = useState(new Date());
//     const [starting, setStarting] = useState(new Date());
//     const [sendFilter, setSendFilter] = useState<boolean>(false)
//     const [accessToken, setAccessToken] = useState<string | null>(null);
//     const [apiCalendar, setApiCalendar] = useState<ApiCalendar | null>(null);
//
//     console.log(scheduleData,'scheduleData')
//
//     useEffect(() => {
//         setAccessToken(calendarData.accessToken);
//     }, [calendarData]);
//
//
//     const handleShowMoreEvents = (events: EventType[], date: Date) => {
//         handleShowMore(events, eventsData, setSelectedEvents, setIsModalOpen);
//     };
//
//     const customHandleSelectSlot = ({start, end}: DateRange) => {
//         handleSelectSlot(start, end, eventsData, setSelectedEvents, setIsModalOpen, setStarting);
//     };
//
//
//     // const apiCalendar = new ApiCalendar(googleCalendarConfig({
//     //     clientId: scheduleData.clientId,
//     //     apiKey: scheduleData.apiKey
//     // }));
//
//
//
//     useEffect(() => {
//         if (scheduleData.clientId && accessToken) {
//             const newApiCalendar = new ApiCalendar(googleCalendarConfig({
//                 clientId: scheduleData.clientId,
//                 apiKey: scheduleData.apiKey,
//                 accessToken: accessToken // Добавляем токен доступа
//             }));
//             setApiCalendar(newApiCalendar);
//         }
//     }, [scheduleData.clientId, accessToken]);
//
//
//
//
//     useEffect(() => {
//         if (scheduleData.data && typeof scheduleData.data === 'object') {
//             const newEventsData = Object.values(scheduleData.data).flatMap((eventGroup) => (
//                 eventGroup.map((event) => ({
//                     id: event.id,
//                     title: event.title,
//                     start: new Date(event.startAt),
//                     end: new Date(event.finishAt),
//                     status: event.status,
//                     problems: event.problems,
//                     hasProblem: event.hasProblems,
//                 }))
//             ));
//
//             setEventsData(newEventsData);
//         }
//     }, [scheduleData]);
//
//
//
//     useEffect(() => {
//         const handleSelectEvent = async () => {
//             try {
//
//                 console.log('try здесь')
//
//                 const queryOptions = buildQueryOptions(currentMonthYear);
//
//                 if (apiCalendar) {
//                     const eventsList = await fetchEventsList(apiCalendar, accessToken, queryOptions);
//
//                     console.log(queryOptions,'queryOptions')
//                     console.log(eventsList,'eventsList')
//
//                     if (eventsList && eventsList.length > 0) {
//                         const uniqueEvents = findUniqueEvents(eventsList);
//
//                         if (uniqueEvents.length > 0) {
//                             await Promise.all([loadingGoogleCalendar(), addUniqueEvents(uniqueEvents)]);
//                             successGoogleCalendar();
//                         } else {
//                             infoGoogleCalendar();
//                         }
//                     } else {
//                         await Promise.all([loadingGoogleCalendar(), addAllEvents()]);
//                         await successGoogleCalendar();
//                     }
//                 } else {
//                     console.error('apiCalendar не инициализирован');
//                 }
//             } catch (error) {
//                 console.log('здесь catch')
//                 console.error('Ошибка:', error);
//             }
//         };
//         handleSelectEvent()
//     }, [eventsData]);
//
//
//     const findUniqueEvents = (eventsList: any) => {
//         return eventsData.filter(eventDataItem => !eventsList.some((eventListItem: any) =>
//             eventDataItem.title === eventListItem.summary &&
//             new Date(eventDataItem.start).getTime() === new Date(eventListItem.start.dateTime).getTime() &&
//             new Date(eventDataItem.end).getTime() === new Date(eventListItem.end.dateTime).getTime()
//         ));
//     };
//
//
//     const addUniqueEvents = async (uniqueEvents: any) => {
//         for (const uniqueEvent of uniqueEvents) {
//             try {
//                 if (apiCalendar) { // Проверка на существование apiCalendar
//                     const formattedEvent = formatEvent(uniqueEvent);
//                     const addedEvent = await apiCalendar.createEvent(formattedEvent);
//                     console.log('Добавлено событие в Google Calendar:', addedEvent);
//                 }
//             } catch (error) {
//                 console.error('Ошибка при добавлении события в Google Calendar:', error);
//             }
//         }
//     };
//
//
//     const formatEvent = (eventDataItem: any) => {
//
//         return {
//             summary: eventDataItem.title,
//             start: {
//                 dateTime: new Date(eventDataItem.start).toISOString(),
//                 timeZone: eventDataItem.timeZone,
//             },
//             end: {
//                 dateTime: new Date(eventDataItem.end).toISOString(),
//                 timeZone: eventDataItem.timeZone,
//             },
//         };
//     };
//
//     const addAllEvents = async () => {
//         for (const eventDataItem of eventsData) {
//             try {
//                 if (apiCalendar) {
//                     const formattedEvent = formatEvent(eventDataItem);
//                     const addedEvent = await apiCalendar.createEvent(formattedEvent);
//                     console.log('Добавлено событие в Google Calendar:', addedEvent);
//                 }
//             } catch (error) {
//                 console.error('Ошибка при добавлении события в Google Calendar:', error);
//             }
//         }
//     };
//
//
//     const getMonthNumber = (date: Date) => {
//         return date.getMonth() + 1;
//     };
//
//     const fetchScheduleData = (newDate: Date) => {
//         setCurrentMonthYear(newDate)
//         const month = getMonthNumber(newDate).toString();
//         const year = newDate.getFullYear().toString();
//         dispatch(fetchSchedule({
//             month: month,
//             year: year,
//             time_zone: selectedTimeZone,
//             new: pendingFilters?.isNew ? 1 : 0,
//             finished: pendingFilters?.finished ? 1 : 0,
//             has_problem: pendingFilters?.has_problem ? 1 : 0,
//             groupId: groupId
//         }));
//     };
//
//
//
//     useEffect(() => {
//         const month = getMonthNumber(currentMonthYear).toString();
//         const year = currentMonthYear.getFullYear().toString();
//         dispatch(fetchSchedule({
//             month: month,
//             year: year,
//             time_zone: selectedTimeZone,
//             new: pendingFilters?.isNew ? 1 : 0,
//             finished: pendingFilters?.finished ? 1 : 0,
//             has_problem: pendingFilters?.has_problem ? 1 : 0,
//             groupId: groupId
//         }));
//
//     }, [dispatch, sendFilter, selectedTimeZone, groupId]);
//
//     const handleOk = () => {
//         setIsModalOpen(false);
//     };
//
//     const handleCancel = () => {
//         setIsModalOpen(false);
//     };
//
//     const {components} = useMemo(() => ({
//         components: {
//             toolbar: (props: ToolbarProps<Event, object>) => (
//                 <CustomToolbar
//                     onNavigate={props.onNavigate}
//                     label={props.label}
//                     date={props.date}
//                     view={props.view}
//                     views={props.views}
//                     localizer={props.localizer}
//                     onView={props.onView}
//                     setSelectedTimeZone={setSelectedTimeZone}
//                     setSendFilter={setSendFilter}
//                 />
//             ),
//             event: (props: any) => (
//                 <EventComponent
//                     status={props.event.status}
//                     hasProblem={props.event.hasProblem}
//                     start={props.event.start}
//                 />
//             ),
//         }
//     }), []);
//
//     const formattedDate = formatDate(new Date(starting));
//
//     return (
//         <div className='calendarContainer'>
//             <Calendar
//                 views={["month"]}
//                 selectable
//                 localizer={localizer}
//                 defaultDate={new Date()}
//                 defaultView="month"
//                 events={eventsData}
//                 onSelectEvent={customHandleSelectSlot}
//                 onSelectSlot={customHandleSelectSlot}
//                 onShowMore={handleShowMoreEvents}
//                 onNavigate={(newDate, view, action) => fetchScheduleData(newDate)}
//                 components={components}
//             />
//             {/*model*/}
//             <CustomModal
//                 selectedEvents={selectedEvents}
//                 formattedDate={formattedDate}
//                 isModalOpen={isModalOpen}
//                 handleOk={handleOk}
//                 handleCancel={handleCancel}
//             />
//
//         </div>
//     );
// };
//
